
import { Box, Modal } from '@mui/material';
import { useModalesStore } from '../../../store';
import { envVariables } from '../../../helpers';

const url = envVariables.REACT_APP_API_URL;




export const ModalVerImagen = ({ img, carpeta}) => {

    

    const { modalImagen, changeEstadoModalImagen } = useModalesStore();
    const fileUrl = img ? `${url}/uploads/${carpeta}/${img}` : `${url}/uploads/${carpeta}/xxxx`;


    const cerrarModal = () => {
        changeEstadoModalImagen(false);
    }


    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={ modalImagen }
            onClose={ cerrarModal }
            closeAfterTransition
        >

            <Box className="modal-estilo" sx={{ width: { xs: '75%', sm: '65%', md: '50%' } }}>
                {(img?.toLowerCase().endsWith('.pdf'))
                ?    <iframe
                        src={`${url}/uploads/${carpeta}/${img}`}
                        style={{ width: '100%', height: '80vh', border: 'none' }}
                        title="PDF Viewer"
                    />

                :   <img
                        style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                        src={ fileUrl }
                        alt="Imagen"
                    />
                }

            </Box>
        </Modal>
    )

}
